export { MagazineReport } from '@/components/clientReport';
import { MagazineReport } from '@/components/clientReport';
import { DEMO } from './demoReportFixture';

export default function ClientReportDemo() {
  return <MagazineReport data={DEMO} isDemo={true} />;
}
